/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntegrationEndpoint from './integration-endpoint';
import IntegrationEndpointDetail from './integration-endpoint-detail';
import IntegrationEndpointUpdate from './integration-endpoint-update';
import IntegrationEndpointDeleteDialog from './integration-endpoint-delete-dialog';

const IntegrationEndpointRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntegrationEndpoint />} />
    <Route path="new" element={<IntegrationEndpointUpdate />} />
    <Route path=":id">
      <Route index element={<IntegrationEndpointDetail />} />
      <Route path="edit" element={<IntegrationEndpointUpdate />} />
      <Route path="delete" element={<IntegrationEndpointDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntegrationEndpointRoutes;
